(function () {
    const closeModalContainer = (cmpModalContainer) => {
        window.adobeDataLayer.push({
            event: 'cmp:hide',
            context: {
                category: 'modal',
                action: 'close',
                id: cmpModalContainer.getAttribute('id'),
                component: 'Modal Container Cheerios'
            }
        });

        cmpModalContainer.parentElement.style.display = "none";
    };

    const openModalContainer = (cmpModalContainer) => {
        cmpModalContainer.style.display = "block";
        cmpModalContainer.parentElement.style.display = "block";

        window.adobeDataLayer.push({
            event: 'cmp:show',
            context: {
                category: 'modal',
                action: 'open',
                id: cmpModalContainer.getAttribute('id'),
                component: 'Modal Container Cheerios'
            }
        });
    };

    const openModalAfterPopuptime = (popuptime, cmpModalContainer) => {
        if (popuptime) {
            setTimeout(function () {
                openModalContainer(cmpModalContainer);
            }, popuptime)
        }
    };

    const launchModalOnLinkClickHandler = (cmpModalContainer) => {
        const selector = `a[href^='#${cmpModalContainer.getAttribute('id')}']`
        const hrefElementList = document.querySelectorAll(selector);
        hrefElementList.forEach(anchor => {
            anchor.addEventListener("click", ((e) => {
                e.preventDefault();
                openModalContainer(cmpModalContainer);
            }));
        })
    }

    const modalContainerInit = (cmpModalContainer, modalContainerData) => {
        const modalContainerOverlay = cmpModalContainer.querySelector('.cmp-modal-container__overlay');
        const modalContainerCloseButton = cmpModalContainer.querySelector('.cmp-modal-container__close');
        const backgroundClickAction = modalContainerData["cmpBackgroundclickaction"] ? modalContainerData["cmpBackgroundclickaction"] : false;
        // modalContainerCloseNestedButton is intended for nesting a cheerios button to be used to close the modal. Must apply "button--close-modal" to component policy to take effect.
        const modalContainerCloseNestedButtonList = cmpModalContainer.querySelectorAll('.cmp-modal-container__body .button--close-modal > .cmp-button');

        if (backgroundClickAction === 'closeModal') modalContainerOverlay.addEventListener('click', ()=>closeModalContainer(cmpModalContainer));

        modalContainerCloseButton.addEventListener('click', ()=>closeModalContainer(cmpModalContainer));

        // checking for class in case .button--close-modal is forgotten by the author.
        if (modalContainerCloseNestedButtonList) {
            modalContainerCloseNestedButtonList.forEach(modalContainerCloseNestedButton => {
                modalContainerCloseNestedButton.addEventListener('click', () => closeModalContainer(cmpModalContainer));
            })
        }
    };




    const domLoaded = () => {
        const modalContainerList = document.querySelectorAll('.modalcontainer');

        if (modalContainerList !== null) {
            modalContainerList.forEach(modalContainer => {
                const cmpModalContainer = modalContainer.querySelector(':scope >.cmp-container');
                const modalId = cmpModalContainer.getAttribute('id');
                const ssModalLoadOptionsPropertyName = `cheerios-modal-container-${modalId}-load-options`
                window.adobeDataLayer = window.adobeDataLayer || [];
                const modalContainerData = cmpModalContainer.dataset;
                const loadoptions = modalContainerData["cmpModalloadoptions"] ? modalContainerData["cmpModalloadoptions"] : false;
                const loadOptionsInSession = sessionStorage.getItem(ssModalLoadOptionsPropertyName);
                const isAuthor = cmpModalContainer.classList.contains('isAuthor');
                const popuptime = modalContainerData["cmpModalpopuptime"] ? parseInt(modalContainerData["cmpModalpopuptime"]) * 1000 : false;

                if (isAuthor) {
                    cmpModalContainer.style.display = "block";
                } else {
                    modalContainerInit(cmpModalContainer, modalContainerData);

                    if (loadoptions === "oncePerSession") {
                        if (loadoptions !== loadOptionsInSession) {
                            sessionStorage.setItem(ssModalLoadOptionsPropertyName, loadoptions);
                            openModalAfterPopuptime(popuptime, cmpModalContainer);
                        }
                    } else {
                        sessionStorage.setItem(ssModalLoadOptionsPropertyName, loadoptions);
                        openModalAfterPopuptime(popuptime, cmpModalContainer);
                    }

                    launchModalOnLinkClickHandler(cmpModalContainer);
                }
            })
        }


    };

    if (document.readyState !== "loading") {
        domLoaded();
    } else {
        document.addEventListener("DOMContentLoaded", domLoaded);
    }
})();
